// OrderActionButton.jsx
import React from 'react';

export const OrderActionButton = ({
  isFreeOrder,
  isExistingOrder,
  restaurant_profile,
  disabled,
  isLoading,
  onClick,
}) => {
  const orderTypeText = restaurant_profile?.config?.use_order_lang
    ? 'Order'
    : 'Tab';

  const buttonText = isExistingOrder
    ? `Add to Your ${orderTypeText}`
    : `Start Your ${orderTypeText}`;

  const displayText = isFreeOrder ? `${buttonText} (Free)` : buttonText;

  return (
    <div className="mx-4 mb-8">
      <button
        onClick={onClick}
        disabled={disabled || isLoading}
        className={`w-full flex justify-center items-center px-8 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white ${
          disabled || isLoading
            ? 'bg-gray-400'
            : 'bg-primary hover:bg-primary/90'
        }`}
      >
        {displayText}
      </button>
    </div>
  );
};
